const STREET = "3020 High Ridge Rd, Boynton Beach, FL 33426";

const isApple = () => /iphone|ipad|ipod|macintosh/i.test(navigator.userAgent);

// Apple Maps can't geocode "Suite 600A", so the suite is left out of the map query.
export function mapsUrl(address = STREET) {
  const addr = address.replace(/,?\s*(suite|ste\.?|unit|#)\s*[\w-]+/i, "");
  const q = encodeURIComponent(addr);
  return isApple()
    ? `https://maps.apple.com/?daddr=${q}&q=${encodeURIComponent("XMD Productions")}`
    : `https://www.google.com/maps/search/?api=1&query=${q}`;
}
